var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80494 11.8175L12.4619 17.7505C12.6219 18.0105 12.8719 18.0075 12.9729 17.9935C13.0739 17.9795 13.3169 17.9175 13.4049 17.6225L17.9779 2.17753C18.0579 1.90453 17.9109 1.71853 17.8449 1.65253C17.7809 1.58653 17.5979 1.44553 17.3329 1.52053L1.87695 6.04653C1.58394 6.13253 1.51994 6.37853 1.50594 6.47953C1.49194 6.58253 1.48794 6.83753 1.74695 7.00053L7.74794 10.7535L13.0499 5.39553C13.3409 5.10153 13.8159 5.09853 14.1109 5.38953C14.4059 5.68053 14.4079 6.15653 14.1169 6.45053L8.80494 11.8175ZM12.8949 19.4995C12.1989 19.4995 11.5609 19.1455 11.1849 18.5375L7.30794 12.2465L0.951945 8.27153C0.266945 7.84253 -0.091055 7.07853 0.019945 6.27553C0.129945 5.47253 0.680945 4.83453 1.45494 4.60753L16.9109 0.0815275C17.6219 -0.126473 18.3839 0.0705274 18.9079 0.592527C19.4319 1.11953 19.6269 1.88953 19.4149 2.60353L14.8419 18.0475C14.6129 18.8245 13.9729 19.3735 13.1719 19.4805C13.0779 19.4925 12.9869 19.4995 12.8949 19.4995Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.684c18428d1c456345826e384838ef0c.svg";
export { ForwardRef as ReactComponent };